var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 597.963,
    height: 348.991,
    viewBox: "0 0 597.963 348.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(-745.102 -293.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(745.102 293.961)",
    opacity: 0.441
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M207.892,2.677S362.068,24.608,347.717,63.953s76.724-13.975,113.069.21c25.876,10.1,15.532,40.844,28.05,53.232,28.7,28.4,58.057-7.365,94.587,14.1s-5.493,217.514-20.367,217.485l-544.249.014S-21.5,295.184,15.9,261.52s11.721-49.058,7.175-62.068C17.858,184.513-.83,141.862,52.407,123.19c38.585-13.534,39.619-60.848,38.052-69.433,0,0-14.924-67.9,117.433-51.081",
    transform: "translate(-0.001 0.001)",
    fill: "#e9edf5"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBg);
export default __webpack_public_path__ + "static/media/error_bg.9091de9e15d46f236a46f8397c1dc790.svg";
export { ForwardRef as ReactComponent };